var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  $("#agenda-carousel").slick({
    fade: true
  });
});
